module.exports = __webpack_public_path__ + "img/Img11_115568_CeEt-9-Vase308.801087d5.jpg";